/**
 * This utility function handles the cross-browser shenanigans
 * around dispatching custom events. It's likely that this code
 * relies on a polyfill so be sure that one is included somewhere
 * in the app.
 *
 * This is specifically so IE11 doesn't freak the fuck out.
 */
export default eventName => {
  if (typeof Event === 'function') {
    // modern browsers
    window.dispatchEvent(new Event(eventName))
  } else {
    // for IE and other old browsers
    // causes deprecation warning on modern browsers
    const evt = window.document.createEvent('UIEvents')
    evt.initUIEvent(eventName, true, false, window, 0)
    window.dispatchEvent(evt)
  }
}
